var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[(_vm.$wait.any)?_c('div',{staticClass:"loader"},[_c('p',[_c('icon',{attrs:{"name":"spinner","scale":"3","spin":""}})],1)]):_vm._e(),_c('router-view')],1)}
var staticRenderFns = []

export { render, staticRenderFns }